<template>
  <svg class="owner-report-icon" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M7 3h7l4 4v14H7z" />
    <path d="M14 3v5h4" />
    <path d="M10 11h5" />
    <path d="M10 14h5" />
    <path d="M10 17h3" />
    <path d="M6 6H4v15h11v-2" />
  </svg>
</template>

<style scoped>
.owner-report-icon {
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.9;
}
</style>
